import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy URL from when the UI called a SOW an "engagement". That word now
 * belongs to the child — a SOW carries engagements — so the page lives at
 * `/customers/$id/sows/$sowId` and this forwards to it, purely so links and
 * bookmarks minted under the old name keep working.
 *
 * The passthrough `validateSearch` is load-bearing: without a schema of its own
 * this route contributes nothing to `beforeLoad`'s `search`, so `?asOf=`,
 * `?tab=` and `?amend=1` would be dropped on the hop. The target route
 * re-validates whatever arrives, so accepting it untyped here is safe.
 */
export const Route = createFileRoute('/_authenticated/customers/$id/engagements/$engagementId')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/customers/$id/sows/$sowId',
      params: { id: params.id, sowId: params.engagementId },
      search,
      replace: true,
    });
  },
});
